import Vue from 'vue'

const Functions = {

  parseBase64ToImage(base64String, type = 'jpeg') {
    return `data:image/${type};base64,${base64String}`
  },

  formatCurrency(value) {
    value = parseFloat(value.toString().trim().replace(/[^0-9]/g, ''))
    return value.toLocaleString('pt-br', { style: 'currency', currency: 'BRL' })
  }

}

Vue.prototype.$functions = Functions
